import Button, {ButtonProps} from "@mui/material/Button";
import Icon from "./Icon";
import {styled} from "@mui/material/styles";
import CustomButton from "./CustomButton";
import React from "react";
import Tooltip from "@mui/material/Tooltip";

interface Props {
    type: string;

    [x: string]: any;
}

const StyledButton = styled((props: ButtonProps) => <Button {...props} />)(({theme}) => ({
    padding: "4px 17px",
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.primary.light,
    whiteSpace: "nowrap",
    "&:hover": {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.primary.contrastText,
    },
}));

const GenericButton = (props: Props) => {
    const {type, ...rest} = props;

    return (
        <>
            {type === "add" && (
                <CustomButton
                    {...rest}
                    buttonType="textIcon"
                    icon={<Icon icon="plus" fixedWidth={true} sx={{fontSize: "1.25rem"}}/>}
                >
                    Adaugă
                </CustomButton>
            )}

            {type === "add-student" && (
                <CustomButton
                    {...rest}
                    buttonType="textIcon"
                    bgcolor="toolbar"
                    icon={<Icon icon="plus" fixedWidth={true} sx={{fontSize: "1.25rem"}}/>}
                >
                    Adaugă elev
                </CustomButton>
            )}

            {type === "add-teacher-big" && (
                <CustomButton
                    {...rest}
                    buttonType="textIcon"
                    bgcolor="toolbar"
                    icon={<Icon icon="plus" fixedWidth={true} sx={{fontSize: "1.25rem"}}/>}
                >
                    Adaugă profesor
                </CustomButton>
            )}

            {type === "work-plan-generate" && (
                <CustomButton
                    {...rest}
                    buttonType="textIcon"
                    icon={<Icon icon="plus" fixedWidth={true} sx={{fontSize: "1.25rem"}}/>}
                >
                    Generează plan de lucru
                </CustomButton>
            )}

            {type === "edit" && (
                <CustomButton
                    {...rest}
                    buttonType="textIcon"
                    size="medium"
                    icon={<Icon icon="far pen-to-square" fixedWidth={true} sx={{fontSize: "1.25rem"}}/>}
                >
                    Editează
                </CustomButton>
            )}

            {type === "close" && (
                <CustomButton
                    {...rest}
                    buttonType="textIcon"
                    bgcolor="error"
                    icon={<Icon icon="far xmark" fixedWidth={true} sx={{fontSize: "1.25rem"}}/>}
                >
                    Închide
                </CustomButton>
            )}

            {type === "start" && (
                <Tooltip title="Start test">
                    <span>
                         <CustomButton
                             {...rest}
                             width={36}
                             height={36}
                             buttonType="icon"
                             appearance="circle"
                             icon={<Icon icon="far play" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                         />
                    </span>
                </Tooltip>
            )}

            {type === "report" && (
                <Tooltip title="Raport">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            icon={<Icon icon="far chart-line-up" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}

            {type === "answers" && (
                <Tooltip title="Răspunsuri">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            icon={<Icon icon="far list-check" fixedWidth={true} sx={{fontSize: "1rem"}}/>}/>
                    </span>
                </Tooltip>
            )}

            {type === "items" && (
                <Tooltip title="Previzualizare">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            icon={<Icon icon="far eye" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}

            {type === "delete" && (
                <Tooltip title="Șterge">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="error-outlined"
                            borderColor="error.main"
                            icon={<Icon icon="far trash-can" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}

            {type === "delete-from-test" && (
                <Tooltip title="Șterge din test">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="error-outlined"
                            borderColor="error.main"
                            icon={<Icon icon="far trash-can" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                        </span>
                </Tooltip>
            )}

            {type === "delete-from-classroom" && (
                <Tooltip title="Șterge din clasă">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            icon={<Icon icon="far trash-can" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}

            {type === "test-generate" && (
                <CustomButton
                    {...rest}
                    buttonType="textIconSmall"
                    bgcolor="table"
                    icon={<Icon icon="far pen-to-square" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                >
                    Generează test
                </CustomButton>
            )}

            {type === "archive" && (
                <Tooltip title="Arhivează">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            icon={<Icon icon="far box-archive" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}

            {type === "restore" && (
                <Tooltip title="Dezarhivează">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            icon={<Icon icon="far box-archive" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}
            {type === "log" && (
                <Tooltip title="Loguri">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            icon={<Icon icon="fas camera-cctv" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}

            {type === "delete-subscription" && (
                <StyledButton
                    {...rest}
                    variant="contained"
                    size="small"
                    startIcon={<Icon icon="far trash-can" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                >
                    Renunță la abonament
                </StyledButton>
            )}

            {type === "delete-extra" && (
                <StyledButton
                    {...rest}
                    variant="contained"
                    size="small"
                    startIcon={<Icon icon="far trash-can" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                >
                    Renunță la extraopțiune
                </StyledButton>
            )}

            {type === "edit-small" && (
                <Tooltip title="Editează">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            icon={<Icon icon="far pen-to-square" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}

            {type === "add-small" && (
                <Tooltip title="Adaugă în test">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            icon={<Icon icon="plus" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}

            {type === "switch-user" && (
                <CustomButton
                    {...rest}
                    buttonType="textIconSmall"
                    bgcolor="table"
                    icon={<Icon icon="far pen-to-square" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                >
                    Intră în cont
                </CustomButton>
            )}

            {type === "add-classrooms" && (
                <Tooltip title="Adaugă clasă">
                    <span>
                        <CustomButton
                            {...rest}
                            width={36}
                            height={36}
                            buttonType="icon"
                            appearance="circle"
                            bgcolor="table"
                            size="small"
                            icon={<Icon icon="far screen-users" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                        />
                    </span>
                </Tooltip>
            )}

            {type === "replace" && (
                <StyledButton
                    {...rest}
                    variant="contained"
                    size="small"
                    startIcon={<Icon icon="far arrows-rotate" fixedWidth={true} sx={{fontSize: "1rem"}}/>}
                >
                    Înlocuiește item
                </StyledButton>
            )}

            {type === "export" && (
                <CustomButton
                    {...rest}
                    buttonType="textIcon"
                    bgcolor="toolbar"
                    size="medium"
                    icon={<Icon icon="far pen-to-square" fixedWidth={true} sx={{fontSize: "1.25rem"}}/>}
                >
                    Generează raport
                </CustomButton>
            )}

            {type === "report-generate" && (
                <CustomButton
                    {...rest}
                    sxExtra={{marginBottom: {xs: 1, sm: 0}}}
                    buttonType="textIcon"
                    size="medium"
                    icon={<Icon icon="far pen-to-square" fixedWidth={true} sx={{fontSize: "1.25rem"}}/>}
                >
                    Generează raport
                </CustomButton>
            )}

            {type === "logs-generate" && (
                <CustomButton
                    {...rest}
                    sxExtra={{marginRight: 1, marginBottom: {xs: 1, sm: 0}}}
                    buttonType="textIconOutlined"
                    bgcolor="info"
                    borderColor="secondary.light"
                    icon={<Icon icon="fas camera-cctv" fixedWidth={true}/>}
                >Raport loguri</CustomButton>
            )}

            {type === "generate-test" && (
                <CustomButton
                    {...rest}
                    sxExtra={{marginBottom: {xs: 1, sm: 0}}}
                    buttonType="textIcon"
                    icon={<Icon icon="fas plus" fixedWidth={true} />}
                >Generează test</CustomButton>
            )}
        </>
    );
};

export default GenericButton;
